import React from "react";

import ResetPasswordConfirmComp from "./components/General/ResetPasswordConfirm.component";
import Header from "./components/General/Header";

const ResetPasswordConfirm = () => {
  return (
    <>
      <Header />
      <ResetPasswordConfirmComp />
    </>
  );
};

export default ResetPasswordConfirm;
